import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getProjectDetailsById } from "../api/pyxis";
import { IProjectDetails } from "../interfaces/project";
import { IAPIError } from "../interfaces/common";

export const projectDetailsQueryKey = ['projectDetails'] as const;

export const useProjectDetails = (id: string, enabled?: boolean):
  UseQueryResult<IProjectDetails, IAPIError> => {
  return useQuery<IProjectDetails, IAPIError>({
    queryKey: projectDetailsQueryKey,
    queryFn: ({ signal }) => getProjectDetailsById(id, signal),
    enabled
  });
};
